import React from 'react';
import { withRouter } from 'react-router';
import Sidebar from '../components/layout/sidebar/Sidebar';
import Agenda from '../components/agenda/Agenda';

function agenda() {
	return (
		<div id='calendar-page'>
			<Sidebar />
			<Agenda />
		</div>
	);
}

export default withRouter(agenda);
